import { EkycStatus } from './types';
/** 判断stdEkycState字段：ekyc通过状态 */
const stdEkycStatePassMap = ['1', '2'];
/** 判断rawEkycState字段：ekyc其他状态 */
const rawEkycStateStatusMap = [
    { ekycStatus: EkycStatus.empty, state: ['0', '5'] },
    { ekycStatus: EkycStatus.underReview, state: ['1'] },
    { ekycStatus: EkycStatus.rejected, state: ['3', '4'] },
];
/** 格式化ekyc状态 */
export const formatEkycStatus = (ekycRawRes) => {
    /** 返回的这两个字段可能为空，空则当0处理 */
    const { stdEkycState = '0', rawEkycState = '0' } = ekycRawRes;
    if (stdEkycStatePassMap.includes(stdEkycState)) {
        return EkycStatus.pass;
    }
    const ekycStateConfig = rawEkycStateStatusMap.find(item => item.state.includes(rawEkycState));
    return ekycStateConfig === null || ekycStateConfig === void 0 ? void 0 : ekycStateConfig.ekycStatus;
};
